<template>
  <div class="unm__outer the-complete outro__stage">
    <div class="progress__mask-container">
      <div class="progress__mask"/>
    </div>
    <div class="progress__loading-container">
      <span
        :style="{ transform: 'scaleX(' + endValue + ')' }"
        aria-hidden="true"
        class="progress__loading"/>
    </div>
    <div class="progress__background-container">
      <span
        aria-hidden="true"
        class="progress__background"/>
    </div>
    <div class="complete__container">
      <h2 class="heading-main">
        <strong>{{ name || 'Hang Tight' }},</strong>
      </h2>
      <p class="paragraph paragraph-splash">We're processing your quiz</p>
      <div class="progress--holder">
        <progress
          :value="endValue"
          class="progress__hidden"/>
      </div>
      <div class="complete__button-container">
        <button
          :class="endValue == 1 ? 'action-button__show' : 'action-button__hide'"
          class="action-button action-button__turquoise cta-large complete__button"
          @click="advance">
          <span class="action-button__dummy action-button__transparent cta-large">
            <div class="action-button__shadow"/>
          </span>
          See Your Results
        </button>
      </div>
    </div>
    <TheParallax/>
  </div>
</template>

<script>
  import { mapMutations, mapState } from 'vuex';
  import TheParallax from '@/components/TheParallax';

  export default {
    name: 'TheComplete',
    components: {
      TheParallax,
    },
    data() {
      return {
        endValue: 0,
      };
    },
    computed: {
      progress() {
        return `${(this.endValue * 100).toFixed()}%`;
      },
      ...mapState(['stage', 'name']),
    },
    created() {
      this.setTitle('Complete');
      this.setHud({
        top: null,
        bottom: null,
      });
    },
    mounted() {
      setTimeout(this.process, 750);
    },
    methods: {
      process() {
        [
          {
            delay: 750,
            endValue: 0.4,
          }, {
            delay: 750,
            endValue: 0.7,
          }, {
            delay: 750,
            endValue: 1,
          },
        ].forEach(({ delay, endValue }) => {
          setTimeout(() => {
            this.endValue = endValue;
          }, delay);
        });
      },
      advance() {
        this.setStage('results');
      },
      ...mapMutations([
        'setTitle',
        'setStage',
        'setHud',
      ]),
    },
  };
</script>

<style lang="scss">

.complete__container {
  @include z-index(content);

  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-direction: column;
  text-align: center;

  @include breakpoint(large) {
    margin-top: -40px;
  }
}

.complete__button-container {
  @include flex-grid-row;
  @include flex-grid-column(12);
  width: 100%;
  justify-content: center;
}

.complete__button {

  &.v-enter,
  &.v-leave-to {
    opacity: 0;
  }

  &.v-enter-active,
  &.v-leave-active {
    transition-duration: $transition-duration;
    transition-property: opacity;
    transition-timing-function: $transition-timing-function;
  }
}

$processing-height: 16px;
$processing-width: 220px;

.progress--holder {
  position: relative;
  margin: 34px auto 42px auto;
  width: $processing-width;
  height: $processing-height;
}

.progress__mask-container,
.progress__loading-container,
.progress__background-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  user-select: none;
  pointer-events: none;
}

.progress__loading,
.progress__background {
  position: relative;
  display: block;
  width: $processing-width;
  height: $processing-height;
}

.progress__mask-container {
  @include z-index(progress-mask);
}

.progress__loading-container {
  @include z-index(progress);
}

.progress__background-container {
  @include z-index(progress-background);
}

.progress__loading {
  background-color: $cherry;
  transform-origin: left;
  transition: transform $progress-transition-duration $progress-transition-timing-function;
}

.progress__background {
  background-color: rgb(25, 90, 93);
}

.progress__mask {
  position: relative;
  width: $processing-width;
  height: $processing-height;
  background-color: $cherry;
  transform-origin: center;
  transition:
    left $stage-transition-duration/3 $transition-timing-function,
    width $stage-transition-duration/3 $transition-timing-function,
    top $stage-transition-duration/3 $transition-timing-function $stage-transition-duration/2,
    height $stage-transition-duration/3 $transition-timing-function $stage-transition-duration/2;
    will-change: width, height;
}

.progress__hidden {
  position: absolute;
  display: block;
  appearance: none;
  width: $processing-width;
  height: $processing-height;
  opacity: 0;
}

.complete__background {
  background-image: url("/images/backgrounds/background-glyph-01.svg");
  background-size: cover;
}

.complete__image {
  background-image: url("/images/graphics/white-texture.png");
  background-repeat: repeat;
}

.complete__overlay {
  background-color: $turquoise;
}

.the-complete {

  &.v-enter,
  &.v-leave-to {
    opacity: 0;
  }

  &.v-enter-active {
    transition-duration: $stage-transition-duration;
  }

  &.v-leave-active {
    transition-delay: $stage-transition-duration;

    .progress__mask {
      width: 100%;
      height: 100%;
    }
  }

  &.v-enter-active,
  &.v-leave-active {
    transition-duration: $stage-transition-duration;
    transition-property: opacity;
    transition-timing-function: $transition-timing-function;
  }
}

.complete__button {
  transition-duration: $transition-duration;
  transition-property: all;
  transition-timing-function: $transition-timing-function;
}

.action-button__hide {
  border-color: $silver !important;
  color: $silver !important;
  opacity: 0.5;
  user-select: none;
  pointer-events: none;
}

.action-button__show {
  border-color: auto !important;
  color: $white !important;
  opacity: 1;
  user-select: all;
  pointer-events: all;
}
</style>



// WEBPACK FOOTER //
// src/components/TheComplete.vue